import * as _ from 'lodash';
import {DataApi} from 'modules/products/v2_0/product-compare/components/DataApi.tsx';
import {OverallScoreHelper, ImageURLHelper} from 'modules/shared/helpers/HelperFunctions.ts';
import {CompareModelStorageManager} from 'modules/shared/helpers/CompareModelStorageManager.ts';

class CompareModelStore {

    constructor() {
        this.overallScoreHelper = new OverallScoreHelper();
        this.compareModelStorageManager = new CompareModelStorageManager();
        this.imageURLHelper = new ImageURLHelper();
    }

    getModels(data) {
        const bucket = this.compareModelStorageManager.getModelIds(parseInt(data.superCategoryId));
        const currentModel = parseInt(data.currentModelId);
        const modelIds = _.uniq(_.concat(bucket, currentModel));

        DataApi.getProductsNew(modelIds).then((models) => {
            let bucketData = [];
            let currentModelData = {};

            _.forEach(bucket, (value, key) => {
                let model = this._transformToCompareModel(_.find(models, {_id: value}));
                if (model) {
                    bucketData.push(model);
                }
            });
            currentModelData = this._transformToCompareModel(_.find(models, {_id: currentModel}));

            data.callback(currentModelData, bucketData)
        });
    }

    addModelToBucket(id) {
        this.compareModelStorageManager.addModel(id);
    }

    removeModelFromBucket(id) {
        this.compareModelStorageManager.removeModelById(id);
    }

    _transformToCompareModel(model) {
        if (model) {
            const brandName = model.brandName;
            const modelName = model.modelName;
            const overallScoreValue = _.round(model.overallDisplayScore, 0);
            let recommendedType = '';
            let overallScoreType = this.overallScoreHelper.getOverallScoreType(overallScoreValue, null);

            if (model.expertRatings.isBestBuy) {
                recommendedType = 'best-buy';
            } else if (model.expertRatings.isRecommended) {
                recommendedType = 'recommended';
            } else if (model.expertRatings.isDontBuy) {
                recommendedType = 'dont-buy';
                overallScoreType = 'dont-buy';
            }

            if (!(model.testStateName == 'Tested' || model.overallDisplayScore)) {
                overallScoreType = 'in-test';
            }

            return {
                id: +model._id,
                name: {
                    brandName: brandName,
                    productName: modelName,
                    displayName: model.modelName,
                },
                recommendedType: recommendedType,
                overallScore: {
                    value: overallScoreValue,
                    type: overallScoreType
                },
                imageSource: this.imageURLHelper.getImageURLNew(model.profileImage),
                superCategoryId: model.productGroupHierarchy.superCategoryId.toString(),
                superCategoryName: model.productGroupHierarchy.superCategoryName,
                overviewUrl: `/products/${model.productGroupHierarchy.categorySlugName}/${model.slugName}/overview/`,
                ratingsUrl: model.productGroupHierarchy.superCategorySlugName === 'tires' ?
                    `/products/tires/ratings/?type=${model.productGroupHierarchy.categorySlugName}` :
                    `/products/${model.productGroupHierarchy.categorySlugName}/ratings-overview/`
            };
        }
    }

}

export default new CompareModelStore();



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/storages/CompareModelStore.js